import React from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductDetails } from './components/ProductDetails';
import { Bonuses } from './components/Bonuses';
import { PricingCards } from './components/PricingCards';
import { CateringElite } from './components/CateringElite';
import { MoreTestimonials } from './components/MoreTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-brand-cream font-sans selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <StatsBar data-id="element-2" />
      <Testimonials data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductDetails data-id="element-5" />
      <Bonuses data-id="element-6" />
      <PricingCards data-id="element-7" />
      <CateringElite data-id="element-8" />
      <MoreTestimonials data-id="element-9" />
      <Guarantee data-id="element-10" />
      <FAQ data-id="element-11" />
      <CostComparison data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
      <SocialProofPopup data-id="element-15" />
    </div>;
}